import React from 'react';
import styles from './toolbar.module.css';

interface ToolbarCheckboxProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

/**
 * Boolean filter rendered as a native checkbox + label. The toggle equivalent
 * of `ToolbarChip` (same `label`/`active`/`onClick` API) — use this for on/off
 * and multi-select ("any of N") filters; reserve `ToolbarChip` for cases that
 * still want the pill look.
 */
export const ToolbarCheckbox: React.FC<ToolbarCheckboxProps> = ({
  label,
  active,
  onClick,
}) => (
  <label className={`${styles.checkbox}${active ? ` ${styles.checkboxActive}` : ''}`}>
    <input type="checkbox" checked={active} onChange={onClick} />
    {label}
  </label>
);
